module.exports = "<app-header [data] = \"data\"></app-header>\n\n<app-content [data] =\"data\" ></app-content>\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/main/main.component.html
// module id = ./src/app/components/main/main.component.html
// module chunks = main